import React from "react";
import Image from "next/image";
import { cn } from "@/storyblok/utils/cn";
import Title from "../texts/Title";
import MembersCard from "@/library/components/members/MembersCard";
import RichTextBlock from "@/storyblok/block-library/rich-texts/RichTextBlock";

export default function MembersGrid({ blok }) {
  const {
    title,
    titleAs,
    titleColor,
    membersGrid = [],
    backgroundColor,
    description,
    descriptionColor,
  } = blok;

  const mappedMembersGrid = membersGrid.map((member) => {
    const customImage = member.image?.filename;
    const defaultImage = "/images/Logo.png";
    return {
      id: member._uid,
      name: member.name,
      role: member.title,
      image: customImage ? `${customImage}/m/100x100` : defaultImage,
      summary: member.summary,
      alt: member.image?.alt,
    };
  });

  const backgroundClasses = cn("px-2 sm:px-8 py-16", {
    "bg-bg-color-white": backgroundColor === "bg-white",
    "bg-bg-color-light": backgroundColor === "bg-light",
    "bg-bg-color-dark": backgroundColor === "bg-dark",
    "bg-bg-color-grey": backgroundColor === "bg-grey",
    "bg-bg-color-orange": backgroundColor === "bg-orange",
  });

  const descriptionClasses = cn("my-6 px-1 lg:max-w-7xl", {
    "text-textPrimary": descriptionColor === "textPrimary",
    "text-textSecondary": descriptionColor === "textSecondary",
    "text-textBlack": descriptionColor === "textBlack",
    "text-textLight": descriptionColor === "textLight",
    "text-textWhite": descriptionColor === "textWhite",
    "text-textGrey": descriptionColor === "textGrey",
    "text-textOrange": descriptionColor === "textOrange",
  });

  return (
    <section className={`${backgroundClasses}`}>
      <div className="container max-w-7xl mx-auto px-2 sm:px-4 my-8">
        <div>
          <Title
            title={title}
            titleColor={titleColor}
            titleAs={titleAs}
            className={"text-center drop-shadow-md font-semibold"}
          />
          {description && (
            <RichTextBlock
              content={description}
              className={descriptionClasses}
            />
          )}
        </div>
        <div>
          <div className="grid grid-cols-1 md:grid-cols-4  my-12 gap-y-12 md:gap-x-12">
            {mappedMembersGrid.map((member) => (
              <MembersCard member={member} key={member.id} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
